export const dataHooks = {
    testimonial: 'testimonial',
    testimonialAvatar: 'testimonialAvatar',
    testimonialText: 'testimonialText',
    testimonialAuthorName: 'testimonialAuthorName',
};
//# sourceMappingURL=constants.js.map